<ion-button class="dark" type="button" (click)="showMenu = true">
  Logg ut
</ion-button>

<ion-modal
[isOpen]="showMenu"
[backdropDismiss]="true"
cssClass="logout-modal-content"
(didDismiss)="showMenu != showMenu"
>
  <ng-template>
    <div class="modalClose">
      <img src="/assets/img/shared/close.svg" (click)="closeThisModal()" />
    </div>
    
    <ion-content>
      <div>
        <ion-grid class="logout-grid">
          <ion-row>
            <ion-col>
              <ion-title class="smaller">
                <h1>Logg ut</h1>
              </ion-title>
            </ion-col>
          </ion-row>
    
          <ion-row>
            <ion-col class="m-block">
              <p>
                Er du sikker på at du ønsker å logge ut?
              </p>
              <p>
                Om du velger å logge ut må du logge inn med brukernavn og passord selv om du har huket av for "Husk meg"
                neste gang du skal bruke appen.
              </p>
            </ion-col>
          </ion-row>
    
          <ion-row>
            <ion-col class="button-container">
              <ion-button class="dark" type="button" (click)="logout()"
              >Logg ut
              </ion-button>
            <ion-button class="secondary" type="button" (click)="closeThisModal()"
              >Avbryt
            </ion-button>
            </ion-col>
          </ion-row>
    
        </ion-grid>
      </div>
    </ion-content>
    
  </ng-template>
</ion-modal>